/**
 * Nomes dos campos em português, para as mensagens de erro.
 *
 * O backend valida por nome técnico (`entrySemester`), e mostrar isso na tela
 * transfere para o usuário um vocabulário que é nosso, não dele. Este mapa
 * traduz de volta para o rótulo que ele acabou de ler no formulário.
 */
const FIELD_LABELS: Record<string, string> = {
  name: 'Nome',
  email: 'E-mail',
  password: 'Senha',

  // Turma
  discipline: 'Disciplina',
  course: 'Curso',
  level: 'Nível',
  entrySemester: 'Semestre de entrada da turma',
  disciplineSemester: 'Semestre da disciplina',
  academicTerm: 'Período letivo',
  registrationNumber: 'Matrícula',

  // Atividade
  title: 'Título',
  description: 'Enunciado',
  type: 'Tipo',
  flowType: 'Classificação',
};

/** Devolve o rótulo em português, ou o próprio nome se não houver tradução. */
export function fieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? field;
}
